/**
 * @description Decimal fields that were converted to percentage fields for simplified input
 */
export const percentageFields = ['finEAgehoursPrc', 'finEAgehoursBuhPrc'];
